import { newImport } from '@/utils/index.js'

export default [
  // 走进鹏华
  {
    path: '/aboutUs',
    name: 'goPh',
    component: () => newImport('aboutUs/index'),
    meta: {
      title: '走进鹏华',
      routeList: [
        {
          name: '首页',
          url: '/home'
        },
        {
          name: '走进鹏华',
          url: '/aboutUs'
        }
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/routers/module/aboutUs.js